import React, { ComponentProps, ReactEventHandler } from "react";

import "./placeholder-image.css";

const onError: ReactEventHandler<HTMLImageElement> = (e) => {
	const el = e.target as HTMLImageElement;
	// Show transparent image

	el.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
	el.classList.add("placeholder-image--error");
	el.onerror = null;
};

/**
 * Small component that can replaces an img element with:
 * - placeholder with gray background and
 * - better handling of errors
 * Required: Make sure the image has a fixed size (even if image is not yet loaded)
 * Remark: If you wrap a Selection box or Badge, you should add a display: block:
 * https://www.tutorialrepublic.com/faq/how-to-remove-white-space-under-an-image-using-css.php
 */
export const PlaceholderImage = ({ src, className, ...props }: ComponentProps<"img">) => (
	// eslint-disable-next-line jsx-a11y/alt-text
	<img
		src={src}
		className={`placeholder-image ${className || ""}`}
		onError={onError}
		draggable="false"
		{...props}
	/>
);
PlaceholderImage.displayName = "PlaceholderImage";
